var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(2.000000, 2.000000)","strokeWidth":"3"},[React.createElement("circle",{"cx":"14","cy":"14","r":"14","key":0}),React.createElement("path",{"d":"M0,14 L28,14","key":1}),React.createElement("path",{"d":"M14,3.10862447e-16 C17.5017925,3.83369405 19.4918539,8.80884739 19.6,14 C19.4918539,19.1911526 17.5017925,24.1663059 14,28 C10.4982075,24.1663059 8.50814614,19.1911526 8.4,14 C8.50814614,8.80884739 10.4982075,3.83369405 14,0 Z","id":"Path","key":2})]));
}

Globe.defaultProps = {"fill":"none","stroke":"currentColor","viewBox":"0 0 32 32"};

module.exports = Globe;

Globe.default = Globe;
